const fallbackPaginationDetails = {
  nextPageOffset: -1,
  transactionLimit: 0
};

function creditsData(state = {}, action) {
  switch (action.type) {
    case 'SET_CREDITS_DATA':
      return { ...state, ...action.creditsData };
    case 'GET_CREDITS_DATA_SUCCESS':
      return { ...state, success: action.success };

    case 'GET_CREDITS_DATA_FAIL':
      return { ...state, success: action.success };

    case 'SET_FETCHED_NT_CASH_DATA':
      const {
        promotionalCredit: {
          activePointHistoryResponses: existingActivePointHistoryResponses = []
        } = {}
      } = state;
      const {
        activePointHistoryResponses: fetchedActivePointHistoryResponses = [],
        paginationDetails = fallbackPaginationDetails
      } = action.moreNTCashData;
      const newActivePointHistoryResponses = [
        ...existingActivePointHistoryResponses,
        ...fetchedActivePointHistoryResponses
      ];
      const newPromotionalCredit = {
        activePointHistoryResponses: newActivePointHistoryResponses,
        paginationDetails
      };
      return { ...state, promotionalCredit: newPromotionalCredit };

    case 'GET_AJIO_CASH_TRANSFER_STATUS':
      return {
        ...state,
        ajioCashTransferStatus: {
          isFetching: true,
          transactionId: action?.id
        }
      };

    case 'GET_AJIO_CASH_TRANSFER_STATUS_SUCCESS':
      return {
        ...state,
        ajioCashTransferStatus: {
          ...state.ajioCashTransferStatus,
          isFetching: false,
          isSuccess: true,
          transactionData: action.data
        }
      };

    case 'GET_AJIO_CASH_TRANSFER_STATUS_FAILED':
      return {
        ...state,
        ajioCashTransferStatus: {
          ...state.ajioCashTransferStatus,
          isFetching: false,
          isSuccess: false
        }
      };
    case 'SET_CREDITS_PAGINATED_DATA':
      const { creditsData={} } = action;
      return {
        ...state,
        ...creditsData,
        walletHistoryResponses: [
          ...state.walletHistoryResponses,
          ...creditsData.walletHistoryResponses
        ]
      }
    default:
      return state;
  }
}

export default creditsData;
